import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { BookingPackage } from '../../../api';

import './style.sass';

interface LocationState {
  bookingPackages: BookingPackage[];
  transactionId: number;
  currentPackageIndex?: number;
  currentQuantityIndex?: number;
}

function BookingPackages() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const locationState = state as LocationState;

  const [currentPackageIndex, setCurrentPackageIndex] = useState(locationState?.currentPackageIndex ?? 0);
  const [currentQuantityIndex, setCurrentQuantityIndex] = useState(locationState?.currentQuantityIndex ?? 0);

  useEffect(() => {
    if (!locationState || !locationState.bookingPackages || locationState.bookingPackages.length === 0) {
      navigate('/order');
      return;
    }

    // Navigate to the package component for the current package
    const currentPackage = locationState.bookingPackages[currentPackageIndex];

    if (currentPackage && currentQuantityIndex < currentPackage.quantity) {
      // Navigate to package with booking package context
      navigate(`/order/package/${currentPackage.packageId}`, {
        state: {
          bookingPackageContext: {
            bookingPackages: locationState.bookingPackages,
            transactionId: locationState.transactionId,
            currentPackageIndex,
            currentQuantityIndex,
            bookingPackageId: currentPackage.id,
          },
        },
      });
    } else if (currentPackageIndex + 1 < locationState.bookingPackages.length) {
      // Move to next package
      setCurrentPackageIndex(currentPackageIndex + 1);
      setCurrentQuantityIndex(0);
    } else {
      // All packages processed, return to order
      navigate('/order');
    }
  }, [currentPackageIndex, currentQuantityIndex, locationState, navigate]);

  // This component just redirects, so return null while navigating
  return null;
}

export default BookingPackages;
